export const WIDGET_STYLES = {
  '@import': "url('https://use.typekit.net/lqu3kao.css')",
  '.tronic-simple-widget': {
    position: 'fixed !important', // Force fixed positioning
    zIndex: 2147483647, // Maximum safe z-index - ALWAYS above iframe
    display: 'flex !important', // Force display
    visibility: 'visible !important', // Force visibility
    opacity: '1 !important', // Force opacity
    pointerEvents: 'auto !important', // Ensure interactions work
    width: 'fit-content',
    minWidth: '310px',
    minHeight: '67px',
    padding: '12px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-end',
    gap: '12px',
    borderRadius: '16px',
    border: '0.5px solid #808080',
    background: 'rgba(0, 0, 0, 0.45)',
    backdropFilter: 'blur(150px)',
    fontFamily: "'effra', 'Effra', sans-serif !important",
    color: 'white',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  },

  // Unauthenticated state: transparent wrapper
  '.tronic-simple-widget.unauthenticated': {
    padding: '0',
    border: 'none',
    background: 'transparent',
    backdropFilter: 'none',
    gap: '0',
    borderRadius: '0',
  },

  '.tronic-simple-widget.position-top-right': {
    top: '20px',
    right: '20px',
  },

  '.tronic-simple-widget.position-bottom-right': {
    bottom: '20px',
    right: '20px',
  },

  '.tronic-simple-widget.position-bottom-left': {
    bottom: '20px',
    left: '20px',
    alignItems: 'flex-start', // Alinear elementos a la izquierda para bottom-left
  },

  '.tronic-authenticated-content': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    width: '100%',
  },

  '.tronic-user-avatar': {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    overflow: 'hidden',
    flexShrink: 0,
  },

  '.tronic-user-avatar img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },

  '.tronic-default-avatar': {
    width: '100%',
    height: '100%',
    background: 'linear-gradient(45deg, #667eea, #764ba2)',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontWeight: '600',
    fontSize: '14px',
  },

  '.tronic-avatar-placeholder': {
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    overflow: 'hidden',
  },

  '.tronic-avatar-skeleton': {
    width: '100%',
    height: '100%',
    background:
      'linear-gradient(90deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.03))',
    backgroundSize: '200% 100%',
    animation: 'tronic-skeleton-loading 1.8s ease-in-out infinite',
    opacity: 0.5,
    borderRadius: '50%',
  },

  '.tronic-separator': {
    width: '1px !important',
    height: '32px !important',
    background: '#e3e3e8 !important',
    flexShrink: '0 !important',
    display: 'block !important', // Override any display: none from external CSS
    visibility: 'visible !important', // Ensure visibility
    opacity: '1 !important', // Ensure opacity
  },

  '.tronic-points-block': {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    width: '160px',
    flexShrink: 0,
  },

  '.tronic-points-info': {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    flexShrink: 0,
    width: '100px', // Reduced to fit within 150px container
  },

  '.tronic-points-value': {
    fontSize: '14px',
    color: '#e6e6ec',
    fontWeight: '500',
  },

  '.tronic-points-next': {
    fontSize: '12px',
    color: '#e6e6ec',
    fontWeight: '400',
  },

  '.tronic-points-placeholder': {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    flexShrink: 0,
  },

  '.tronic-points-skeleton': {
    height: '14px',
    background:
      'linear-gradient(90deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.03))',
    backgroundSize: '200% 100%',
    animation: 'tronic-skeleton-loading 1.8s ease-in-out infinite',
    opacity: 0.5,
    borderRadius: '2px',
    width: '80px',
  },

  '.tronic-points-skeleton.small': {
    height: '12px',
    width: '60px',
  },

  '.tronic-progress-arc-skeleton': {
    width: '54px',
    height: '28px',
    background:
      'linear-gradient(90deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.03))',
    backgroundSize: '200% 100%',
    animation: 'tronic-skeleton-loading 1.8s ease-in-out infinite',
    opacity: 0.5,
    borderRadius: '6px',
    flexShrink: 0,
  },

  '.tronic-action-buttons': {
    display: 'flex',
    flexShrink: 0,
  },

  '.tronic-action-button': {
    width: '32px',
    height: '32px',
    borderRadius: '100px',
    border: '0.5px solid #9f9fa2',
    background: 'rgba(159, 159, 162, 0.3)',
    backdropFilter: 'blur(26.666667938232422px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    flexShrink: 0,
    outline: 'none',
    position: 'relative',
  },

  '.tronic-action-button:hover': {
    background: 'rgba(159, 159, 162, 0.5)',
    transform: 'scale(1.05)',
  },

  '.tronic-action-button:active': {
    transform: 'scale(0.95)',
  },

  '.tronic-action-button svg': {
    width: '12px',
    height: '12px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    transition: 'opacity 0.2s ease',
  },

  '.tronic-action-button .tronic-icon-open': {
    opacity: 1,
  },

  '.tronic-action-button .tronic-icon-close': {
    opacity: 0,
  },

  '.tronic-action-button.iframe-open .tronic-icon-open': {
    opacity: 0,
  },

  '.tronic-action-button.iframe-open .tronic-icon-close': {
    opacity: 1,
  },

  // CSS Isolation - Protect widget elements from external CSS interference
  '.tronic-simple-widget *': {
    fontFamily: "'effra', 'Effra', sans-serif !important",
  },

  // Ensure Effra font is applied to all widget elements
  '.tronic-simple-widget, .tronic-simple-widget *': {
    fontFamily: "'effra', 'Effra', sans-serif !important",
  },

  // Override any external CSS that might hide widget elements
  '.tronic-simple-widget div:empty': {
    display: 'block !important',
  },

  '.tronic-simple-widget span:empty': {
    display: 'inline-block !important',
  },

  // Override external CSS that hides empty elements
  '.tronic-simple-widget .tronic-separator': {
    display: 'block !important',
    visibility: 'visible !important',
    opacity: '1 !important',
  },

  // Protect skeleton elements from being hidden by external CSS
  '.tronic-simple-widget .tronic-skeleton': {
    display: 'block !important',
    visibility: 'visible !important',
    opacity: '1 !important',
  },

  '.tronic-simple-widget .tronic-skeleton-circle': {
    display: 'block !important',
    visibility: 'visible !important',
    opacity: '0.5 !important', // Keep skeleton opacity
  },

  // Mobile optimizations using JavaScript class - more reliable than media queries
  '.tronic-simple-widget.mobile': {
    minWidth: 'unset !important', // Remove minWidth constraint in mobile
    width: 'fit-content !important', // Adjust to content size
    gap: '8px !important',
    padding: '8px !important', // Reduce padding for more compact look
  },

  '.tronic-simple-widget.mobile .tronic-authenticated-content': {
    gap: '8px !important',
  },

  '.tronic-simple-widget.mobile .tronic-user-avatar': {
    width: '28px !important',
    height: '28px !important',
  },

  '.tronic-simple-widget.mobile .tronic-action-buttons': {
    gap: '6px !important',
  },

  '.tronic-simple-widget.mobile .tronic-action-button': {
    width: '28px !important',
    height: '28px !important',
    border: 0,
  },

  '.tronic-simple-widget.mobile .tronic-action-button svg': {
    width: '14px !important',
    height: '14px !important',
  },

  '.tronic-simple-widget.mobile .tronic-connect-button': {
    height: '48px !important',
    padding: '4px 16px !important',
    minWidth: 'unset !important',
  },

  '.tronic-simple-widget.mobile .connect-button-text': {
    padding: '0 12px !important',
    fontSize: '12px !important',
  },

  '.tronic-connect-button': {
    display: 'flex',
    width: 'auto',
    height: '56px',
    padding: '4px 24px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '9999px',
    background: '#FAFAFF',
    color: '#111010',
    boxShadow: '8px 8px 40px 0px rgba(0, 0, 0, 0.10)',
    border: 'none',
    cursor: 'pointer',
    overflow: 'hidden',
    transition: 'all 0.3s ease',
    outline: 'none',
  },

  '.tronic-simple-widget.theme-dark .tronic-connect-button': {
    background: '#1a1a1a',
    color: '#ffffff',
    boxShadow: '8px 8px 40px 0px rgba(0, 0, 0, 0.30)',
  },

  '.tronic-connect-button:hover': {
    filter: 'brightness(1.1)',
  },

  '.tronic-connect-button:active': {
    filter: 'brightness(0.9)',
  },

  '.tronic-connect-button:disabled': {
    opacity: 0.6,
    cursor: 'not-allowed',
    filter: 'none',
  },

  '.connect-button-text': {
    padding: '0 16px',
    fontSize: '14px',
    letterSpacing: '1.28px',
    textAlign: 'center',
    color: '#111010',
    textTransform: 'uppercase',
    fontWeight: '400',
  },

  '.tronic-simple-widget.theme-dark .connect-button-text': {
    color: '#ffffff',
  },

  '.tronic-progress-arc-container': {
    position: 'relative',
    width: '54px',
    height: '40px',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  '.tronic-progress-arc': {
    width: '100%',
    height: '100%',
  },

  '.tronic-progress-arc path': {
    transition: 'stroke-dasharray 0.3s ease',
  },

  '.tronic-progress-arc text': {
    fontFamily: "'effra', 'Effra', sans-serif !important",
    fontWeight: '500',
  },

  // Recommendation styles
  '.tronic-recommendation-container': {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    borderRadius: '8px',
    padding: '2px',
    flexShrink: 0,
    maxWidth: '160px',
  },

  '.tronic-recommendation-container:hover': {
    background: 'rgba(255, 255, 255, 0.03)',
    transform: 'scale(1.02)',
  },

  '.tronic-recommendation-container:active': {
    transform: 'scale(0.98)',
  },

  '.tronic-recommendation-image': {
    width: '48px',
    height: '32px',
    borderRadius: '6px',
    overflow: 'visible', // Allow indicator to show outside bounds
    flexShrink: 0,
    background: 'rgba(255, 255, 255, 0.1)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative', // For absolute positioning of indicator
  },

  '.tronic-recommendation-image img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '6px',
  },

  '.tronic-recommendation-indicator': {
    position: 'absolute',
    top: '-6px', // Float above the image
    left: '-6px', // Float to the left of the image
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    backgroundColor: 'gray', // Default fallback color
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '12px',
    fontWeight: '700',
    color: 'white',
    zIndex: 10,
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)', // Subtle shadow for depth
  },

  '.tronic-recommendation-placeholder': {
    width: '100%',
    height: '100%',
    background:
      'linear-gradient(90deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.03))',
    backgroundSize: '200% 100%',
    animation: 'tronic-skeleton-loading 1.8s ease-in-out infinite',
    opacity: 0.5,
    borderRadius: '6px',
  },

  '.tronic-recommendation-content': {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    width: '160px',
    minWidth: 0, // Allow text truncation
    maxWidth: '160px',
  },

  '.tronic-recommendation-title': {
    fontSize: '14px',
    color: '#e6e6ec',
    fontWeight: '500',
    lineHeight: '1.2',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    wordBreak: 'break-word',
  },

  '.tronic-recommendation-subtitle': {
    fontSize: '12px',
    color: '#9f9fa2',
    fontWeight: '400',
    lineHeight: '1.2',
  },

  // Mobile adjustments for recommendations
  '.tronic-simple-widget.mobile .tronic-recommendation-container': {
    gap: '8px !important',
  },

  '.tronic-simple-widget.mobile .tronic-recommendation-image': {
    width: '40px !important',
    height: '28px !important',
  },

  '.tronic-simple-widget.mobile .tronic-recommendation-title': {
    fontSize: '12px !important',
    display: '-webkit-box !important',
    '-webkit-line-clamp': '2 !important',
    '-webkit-box-orient': 'vertical !important',
  },

  '.tronic-simple-widget.mobile .tronic-recommendation-subtitle': {
    fontSize: '11px !important',
  },

  '.tronic-simple-widget.mobile .tronic-recommendation-indicator': {
    width: '20px !important',
    height: '20px !important',
    top: '-5px !important',
    left: '-5px !important',
    fontSize: '10px !important',
  },

  '.tronic-simple-widget.mobile .tronic-points-block': {
    gap: '12px !important',
    width: 'auto',
  },

  '.tronic-simple-widget.mobile .tronic-progress-arc-container': {
    width: '50px !important', // Slightly smaller in mobile
  },

  '.tronic-simple-widget.mobile .tronic-points-info': {
    display: 'none !important', // Hide points text in mobile
  },

  '.tronic-simple-widget.mobile .tronic-separator': {
    display: 'none !important', // Hide separators in mobile for cleaner look
  },

  // Skeleton loading animation
  '@keyframes tronic-skeleton-loading': {
    '0%': {
      backgroundPosition: '-200% 0',
    },
    '100%': {
      backgroundPosition: '200% 0',
    },
  },

  // Spinner rotation animation
  '@keyframes tronic-spinner-rotate': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
};
